import * as THREE from 'three';

export class CameraRig {
  private readonly target = new THREE.Vector3(0, 0, -1);

  constructor(
    private readonly camera: THREE.PerspectiveCamera,
    private readonly offset = new THREE.Vector3(0, 14, 10),
  ) {
    this.camera.position.copy(this.offset);
    this.camera.lookAt(this.target);
  }

  resize(): void {
    this.camera.position.copy(this.offset);
    this.camera.lookAt(this.target);
  }
}
